import { useGetIdentity } from "ra-core";
import type { CrmUserIdentity } from "@/components/atomic-crm/types";

export function useCrmIdentity() {
  const { identity, ...rest } = useGetIdentity();
  const crmIdentity = identity as CrmUserIdentity | undefined;
  const role =
    crmIdentity?.role || (crmIdentity?.administrator ? "admin" : "sales");
  const isAdmin = role === "superadmin" || role === "admin";
  const isSuperAdmin = role === "superadmin";

  return {
    identity: crmIdentity,
    role,
    isAdmin,
    isSuperAdmin,
    ...rest,
  };
}
